import {
  BodyLinkV3,
  LayoutGrid,
  TypographyRhythm,
  TypographyV3,
} from '@jouzen/ecom-components';

import PageLayoutV3 from '@/app/components/PageLayoutV3';

const Page = (): JSX.Element => {
  return (
    <PageLayoutV3
      pageName="Terms and Conditions"
      containerProps={{
        name: 'terms-and-conditions',
        padding: 'both',
        lang: 'da',
      }}
      footerProps={{
        wrapperClassName: 'bg-white',
      }}
    >
      <LayoutGrid data-cy="terms-and-conditions-da-page">
        <TypographyRhythm className="col-main">
          <TypographyV3 Element="h1" variant="h1">
            ŌURAS VILKÅR FOR BRUG
          </TypographyV3>
          <BodyLinkV3 color="inherit" href="/da/gen2-terms-and-conditions">
            Tidligere vilkår og betingelser
          </BodyLinkV3>
          <TypographyV3>
            <em>Sidst opdateret: 2. april 2024</em>
          </TypographyV3>
          <TypographyV3>
            Velkommen, og tak for din interesse i Ōura! Disse vilkår for brug (i
            det følgende benævnt "aftalen") beskriver de vilkår og betingelser,
            der gælder for din brug af ouraring.com (i det følgende benævnt
            "webstedet"), smartringen, opladeren og/eller andre elektroniske
            enheder (i det følgende benævnt "produkterne" ), herunder
            Ōura-mobilapplikationen (i det følgende benævnt "mobilappen") (i det
            følgende samlet benævnt "tjenesterne"). Webstedet og mobilappen ejes
            og drives af <strong>Ōura Health Oy</strong> og dets tilknyttede
            selskaber og datterselskaber såsom Ouraring Inc. (i det følgende
            samlet benævnt "Ōura" eller "Oura").
          </TypographyV3>
          <TypographyV3>
            I denne aftale omtaler vi os selv som "Ōura", "Oura", "os" eller
            "vi", og vi omtaler dig som "du", "dig" eller "kunde". Oura og
            kunden omtales i denne aftale individuelt som en "part" og samlet
            som "parterne".
          </TypographyV3>
          <TypographyV3>
            Ved at tilgå eller bruge tjenesterne, herunder webstedet, giver du
            udtryk for din hensigt om og accepterer udtrykkeligt at være bundet
            af alle vilkår og betingelser i denne aftale og i
            privatlivspolitikken (tilgængelig på{' '}
            <BodyLinkV3
              color="inherit"
              href="https://ouraring.com/da/privacy-policy"
              target="_blank"
            >
              https://ouraring.com/privacy-policy
            </BodyLinkV3>
            ), som udgør et bilag til denne aftale. Hvis du ikke accepterer
            disse vilkår og betingelser, må du ikke bruge tjenesterne.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Adgang og brug
          </TypographyV3>
          <TypographyV3>
            Oura giver dig en begrænset licens til at få adgang til webstedet i
            henhold til denne aftale. Hvis du vælger at abonnere på og bruge
            mobilappen, giver Oura dig desuden en licens til at få adgang til og
            bruge tjenesterne i henhold til og betinget af din overholdelse af
            denne aftale, privatlivspolitikken og alle andre regler og krav, der
            er meddelt dig af Oura, herunder din betaling af eventuelle gældende
            gebyrer. Du anerkender og accepterer, at Oura kan tilrette, opdatere
            og på anden måde ændre tjenesterne til enhver tid og efter eget
            skøn.
          </TypographyV3>
          <TypographyV3>
            Du oplyser og garanterer, at du er mindst 18 år gammel og har
            juridisk beføjelse til at acceptere denne aftale på egne vegne eller
            på vegne af enhver part, du repræsenterer. Du er alene ansvarlig for
            dine aktiviteter og interaktion med tjenesterne.
          </TypographyV3>
          <TypographyV3>
            Du må ikke bruge tjenesterne til nogen formål ud over omfanget af
            den adgang, der gives i henhold til denne aftale. Du må ikke på
            noget tidspunkt, direkte eller indirekte, og må ikke tillade nogen
            tredjepart at: (i) kopiere, ændre eller skabe afledte værker af
            tjenesterne, hverken helt eller delvist, (ii) udføre reverse
            engineering, adskille, dekompilere, afkode, tilpasse eller på anden
            måde forsøge at udlede eller få adgang til nogen mobilapp-komponent
            hørende til tjenesterne, hverken helt eller delvist, eller (iii)
            bruge tjenesterne på nogen måde eller til noget formål, der krænker,
            uretmæssigt tilegner sig eller på anden måde krænker nogen persons
            intellektuelle ejendomsret eller andre rettigheder (herunder, men
            ikke begrænset til web-skrabning), eller som på anden måde
            overtræder nogen lov, bestemmelse eller anden form for lovkrav.
          </TypographyV3>
          <TypographyV3>
            Køb er kun beregnet til dig som slutbruger og er ikke godkendt til
            videresalg uden Ouras udtrykkelige tilladelse. Vi forbeholder os
            retten til at afvise eller annullere din ordre, hvis vi har mistanke
            om, at du køber tjenester til videresalg.
          </TypographyV3>
          <TypographyV3>
            Bortset fra den begrænsede licens til at få adgang til webstedet og
            mobilappen, der er omtalt ovenfor, anerkender du, at intet i denne
            aftale skal fortolkes som tildeling eller overdragelse, hverken
            implicit, ved præklusion eller på anden måde, nogen rettighed eller
            ejerskab til eller interesse for nogen intellektuel ejendomsret,
            herunder enhver (i) opfindelse (uanset om den kan patenteres eller
            ej i noget land), patenter, patentansøgninger, afsløringer af
            opfindelser, forbedringer, forretningshemmeligheder, proprietære
            oplysninger, knowhow, information eller tekniske data, (ii)
            ophavsretligt beskyttede værker, copyright-registreringer,
            maskeværker, maskeværksregistreringer eller ansøgninger i USA eller
            et hvilket som helst andet land, (iii) varemærker,
            varemærkeregistreringer, servicemærker, logoer eller ansøgninger
            herom i USA eller et hvilket som helst andet land, (iv)
            forretningshemmeligheder eller (v) andre materielle eller
            immaterielle ejendomsrettigheder noget sted i verden.
          </TypographyV3>
          <TypographyV3>
            Du anerkender og accepterer, at tjenesterne til tider kan være
            utilgængelige eller ubrugelige af en hvilken som helst grund,
            herunder, men ikke begrænset til: (i) udstyrsfejl, (ii) periodiske
            vedligeholdelsesprocedurer eller reparationer, som Oura kan foretage
            fra tid til anden uden varsel til dig, eller (iii) årsager, som
            ligger uden for Ouras kontrol, eller som ikke med rimelighed er
            forudsigelige.
          </TypographyV3>
          <TypographyV3>
            Uanset indhold i denne aftale, der måtte udtrykke det modsatte, kan
            Oura midlertidigt suspendere adgangen til de tjenester, der leveres
            til dig og enhver anden tredjepart af sikkerhedsmæssige årsager, for
            at forhindre ulovlig eller svigagtig aktivitet, for at efterkomme
            anmodninger fra ethvert lovligt agentur eller regeringsorgan, eller
            hvis du overtræder aftalen eller privatlivspolitikken.
          </TypographyV3>
          <TypographyV3>
            Oura kan fra tid til anden og efter eget skøn engagere andre
            tjenesteudbydere til at hjælpe med udførelsen af tjenesterne, såsom
            webhostingudbydere, betalingsbehandlere og andre tredjeparter. Du
            skal overholde vilkårene for brug og andre krav, der er forbundet
            med de tjenester, som leveres af sådanne tredjeparter i forbindelse
            med tjenesterne.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Kundeansvar
          </TypographyV3>
          <TypographyV3>
            Du erkender, at du alene er ansvarlig for din brug af tjenesterne,
            direkte eller indirekte, herunder forståelse af, hvorvidt sådan
            adgang eller brug er tilladt i overensstemmelse med eller i strid
            med denne aftale. Du er yderligere alene ansvarlig for at overholde
            alle gældende love vedrørende din brug af tjenesterne. Du skal
            desuden kun bruge tjenesterne til lovlige formål og skal udføre alle
            aktiviteter gennem tjenesterne i overensstemmelse med alle gældende
            love og regler, herunder, men ikke begrænset til alle gældende
            føderale og statslige love og regler vedrørende tilbud og salg af
            værdipapirer, hvidvaskning af penge og bekæmpelse af terrorisme.
          </TypographyV3>
          <TypographyV3>
            Du er ansvarlig for at sørge for, at du kan få adgang til og bruge
            tjenesterne. Dette indebærer at sikre, at du har det nødvendige
            kompatible hardware, mobilappen, internetadgang, en sikkerhedsapp,
            backup-enheder eller -tjenester og opfylder andre krav. Oura påtager
            sig intet ansvar for at levere yderligere mobilapps eller hardware.
            Du accepterer også, at Oura ikke er ansvarlig for eventuel datatab
            eller andre skader eller tab, der opstår i forbindelse med din brug
            af tjenesterne, herunder manglende sikring af tilstrækkelig
            sikkerhed eller backup-enheder eller -tjenester..
          </TypographyV3>
          <TypographyV3>
            Du er ansvarlig for at sikre, at Oura har nøjagtige og opdaterede
            oplysninger vedrørende din kundekonto, herunder opdaterede
            kontaktoplysninger og betalingsoplysninger. Du er desuden ansvarlig
            for regelmæssigt at tjekke den tilknyttede kundemailkonto for
            eventuelle meddelelser fra Oura.
          </TypographyV3>
          <TypographyV3>
            Hvis du bliver givet et brugernavn, en adgangskode, en
            legitimationsfil eller nogen anden oplysning som en del af en
            sikkerhedsprocedure (i det følgende benævnt
            "legitimationsoplysninger"), skal du behandle sådanne oplysninger
            fortroligt og må ikke videregive legitimationsoplysningerne til
            nogen anden person eller enhed. Du anerkender, at din konto og dine
            legitimationsoplysninger er personlige for dig, og du accepterer
            endvidere ikke at give nogen anden adgang til tjenesterne eller dele
            af tjenesterne ved hjælp af dit brugernavn, din adgangskode eller
            andre sikkerhedsoplysninger. Du skal straks underrette Oura om
            enhver uautoriseret adgang til eller brug af dine
            legitimationsoplysninger eller enhver anden sikkerhedsbrist. Oura
            har ret til at deaktivere ethvert brugernavn, enhver adgangskode,
            enhver legitimationsfil og andre identifikatorer når som helst,
            uanset om det er valgt af dig eller leveret af Oura.
          </TypographyV3>
          <TypographyV3>
            Oura vil iværksætte kommercielt rimelige bestræbelser på at yde
            tilstrækkelige support til tjenesterne. Uanset det foregående
            berettiger denne aftale dig ikke til nogen garanteret grad af,
            tilgængelighed af eller svartid for support til tjenesterne.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Betaling og gebyrer
          </TypographyV3>
          <TypographyV3>
            Betalingstjenester omfatter tjenesterne, som kan være engangskøb
            eller abonnementstjenester, som fornys automatisk (i det følgende
            benævnt "betalingstjenester"), herunder vores websted og mobilapp (i
            det følgende benævnt "abonnementer"). Vi kan til enhver tid foretage
            ændringer i, suspendere eller afbryde betalingstjenester af en
            hvilken som helst årsag, og Oura forbeholder sig retten til efter
            eget skøn at bestemme, hvilke tjenester eller dele deraf der kræver
            betaling.
          </TypographyV3>
          <TypographyV3>
            Betalingstjenester kan omfatte forudbestilte produkter, der vil
            blive produceret til dig i fremtiden (i det følgende benævnt
            "forudbestilling"). Du vil blive opkrævet et forudbestillingsgebyr,
            når du afgiver en forudbestilling. Den faktiske afsendelsesdato for
            enhver accepteret forudbestilling afhænger af en række faktorer,
            herunder, men ikke begrænset til datoen for betaling af dit
            forudbestillingsgebyr og Ouras produktionsplan. Der er ingen garanti
            for afsendelsesdato for forudbestillinger..
          </TypographyV3>
          <TypographyV3>
            Du accepterer at betale alle gældende gebyrer for
            betalingstjenester, herunder uden begrænsning eventuelle månedlige
            abonnementsgebyrer, brugergebyrer og tilbudsgebyrer samt eventuelle
            andre gebyrer, afgifter eller omkostninger, som du accepterer at
            købe som en del af de betalingstjenesterne under betalingsprocessen
            (i det følgende benævnt "gebyrer"). Du accepterer at betale alle
            gebyrer og alle gældende skatter, afgifter og moms, der påløber
            inden opsigelse eller annullering af aftalen..
          </TypographyV3>
          <TypographyV3>
            Du giver Oura tilladelse til at trække betaling på dit udpegede
            betalingsmiddel for betalingstjenester. Ved at oplyse et acceptabelt
            betalingsmiddel erklærer og garanterer du, at du er bemyndiget til
            at bruge det pågældende betalingsmiddel, og at du giver os eller
            vores tredjepartsbetalingsbehandler tilladelse til på dit
            betalingsmiddel at trække det samlede beløb for dit køb, herunder
            eventuelle gældende skatter og andre gebyrer. Hvis betalingsmetoden
            ikke kan verificeres, er ugyldig eller på anden måde ikke
            acceptabel, kan dine betalingstjenester blive suspenderet eller
            annulleret. Du skal løse eventuelle problemer, vi støder på i
            forbindelse med det betalingsmiddel, du angiver, for at fortsætte
            med at bruge tjenesten. Hvis du accepterer et tilbud eller foretager
            ændringer i dine betalingstjenester, kan gebyrerne, skatterne og de
            fakturerede beløb variere. Faktureringsbeløb kan også variere på
            grund af ændringer i gældende skatter eller valutakurser. Du giver
            os eller vores tredjepartsbetalingsbehandler tilladelse til på dit
            betalingsmiddel at trække det tilsvarende beløb. Der vil ikke blive
            udstedt refusioner medmindre påkrævet ved lov. Individuelle rabatter
            kan ikke kombineres med nogen anden rabat. Denne
            betalingsforpligtelse ophører ikke, selv om aftalen opsiges eller
            annulleres, uanset årsag.
          </TypographyV3>
          <TypographyV3>
            Hvis du vælger at finansiere et køb gennem vores
            tredjepartsbetalingsbehandler, og en eller flere varer i din ordre
            har en forlænget afsendelsesdato, kan din lånebetaling(er),
            inklusive renter, være forfaldne, før vi sender alle varerne.
            Bemærk, at du muligvis ikke modtager en tilbagebetaling af
            eventuelle renter, der allerede er akkumuleret på et beløb, der
            senere refunderes.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Abonnementer
          </TypographyV3>
          <TypographyV3>
            Visse betalte tjenester er abonnementsbaserede køb, for hvilke
            følgende vilkår gælder:
          </TypographyV3>
          <TypographyV3>
            <b>
              Din abonnementsperiode kan variere som en kontinuerlig, månedlig
              eller årlig periode (i det følgende benævnt
              "abonnementsperiode(r)") som beskrevet under købet af
              betalingstjenesterne. Dit abonnement vil automatisk blive fornyet
              for yderligere abonnementsperioder, indtil det annulleres af dig
              eller suspenderes eller afsluttes af Oura. Medmindre vi angiver
              andet, vil abonnementsgebyret plus eventuelle gældende skatter og
              andre gebyrer blive trukket på dit angivne betalingsmiddel før
              eller i begyndelsen af hver abonnementsperiode. Inden opkrævning
              for en abonnementsperiode vil vi underrette dig om de gældende
              gebyrer, og fornyelsen vil ske til den pris, der gælder for den
              betalte tjeneste på det pågældende tidspunkt.
            </b>
          </TypographyV3>
          <TypographyV3>
            <b>
              Du kan til enhver tid opsige dit abonnement. Din opsigelse træder
              i kraft ved udgangen af den igangværende abonnementsperiode. For
              at opsige dit abonnement og den automatiske betaling heraf skal du
              klikke på knappen "Opsig konto" på dit kontoskærmbillede eller
              kontakte vores team ved at besøge support.ouraring.com og oprette
              en sag. Annullering giver dig ikke ret til tilbagebetaling af
              tidligere betalte gebyrer, og du vil ikke modtage en
              forholdsmæssig tilbagebetaling for resten af abonnementsperioden.
              I tilfælde af at du opsiger dit abonnement, skal du være opmærksom
              på, at vi stadig kan sende dig salgsfremmende meddelelser,
              medmindre du fravælger at modtage disse meddelelser ved at følge
              afmeldingsinstruktionerne i meddelelserne.
            </b>
          </TypographyV3>
          <TypographyV3>
            <b>
              Når du opsiger et abonnement, annullerer du kun fremtidige gebyrer
              for dit abonnement. Du vil ikke modtage en refusion for den
              igangværende abonnementsperiode, du har betalt for, men du vil
              fortsat have fuld adgang til det pågældende abonnement indtil
              udgangen af den igangværende abonnementsperiode.
            </b>{' '}
            Vi kan til enhver tid og af en hvilken som helst grund give en
            refusion, rabat eller andre modydelser (i det følgende benævnt
            "kreditter") til nogle af eller alle vores brugere. Størrelsen og
            formen af sådanne kreditter og beslutningen om at give dem afgøres
            efter vores eget skøn. Et tilbud om kredit i ét tilfælde giver dig
            ikke ret til kreditter i fremtiden for lignende tilfælde, og det
            forpligter os heller ikke til at give kreditter i fremtiden.
          </TypographyV3>
          <TypographyV3>
            Hvis du bor uden for USA og fortryder dit køb, kan du have ret til
            at få en fuld refusion inden for fjorten (14) dage (i det følgende
            kaldet "fortrydelsesperioden"), forudsat at du ikke har logget ind
            eller på anden måde indløst eller påbegyndt brug af tjenesterne som
            abonnent i fortrydelsesperioden.
          </TypographyV3>
          <TypographyV3>
            Fra tid til anden kan vi tilbyde gratis prøveperioder for visse
            abonnementer i en angiven periode uden betaling.{' '}
            <b>
              Inden starten på din gratis prøveperiode vil vi underrette dig om
              de gældende abonnementsafgifter, der vil blive opkrævet ved
              udløbet af den gratis prøveperiode. Medmindre du opsiger dit
              abonnement inden udløbet af den gratis prøveperiode ved at følge
              trinnene ovenfor, vil vi eller vores tredjepartsbetalingsbehandler
              løbende trække abonnementsafgiften fra din angivne betalingsmetode
              plus eventuelle gældende skatter og andre gebyrer, så længe dit
              abonnement fortsætter. Du skal annullere dit abonnement inden
              udløbet af den gratis prøveperiode for at undgå eventuelle
              afgifter. Instruktioner i opsigelse af abonnementet er beskrevet
              ovenfor.
            </b>
          </TypographyV3>
          <TypographyV3>
            Din betalingsinformation vil blive behandlet og gemt af en
            tredjepartsbetalingsbehandler. Alle betalende kontohavere skal
            opretholde mindst én gyldig betalingsmetode til betaling af gebyrer,
            der er beskrevet mere detaljeret under betalingsprocessen. Alle
            gebyrer beregnes og faktureres til dig månedligt eller årligt
            afhængigt af dit valg og forfalder straks ved modtagelse og kan
            blive ændret. Du accepterer, at gebyrer automatisk opkræves løbende,
            og du accepterer ansvaret for alle løbende omkostninger indtil
            opsigelse. Gebyrer vil blive opkrævet eller trukket fra den gemte,
            angivne betalingsmetode, du oplyser, dagen før den månedlige eller
            årlige dato, hvor det oprindelige køb fandt sted.
          </TypographyV3>
          <TypographyV3>
            I tilfælde af at du ikke har logget ind eller på anden måde har
            brugt tjenesterne i seks (6) måneder eller længere efter køb eller
            modtagelse af et produkt i en gratis prøveperiode, forbeholder vi os
            ret til at opsige dit abonnement, annullere eventuelle afventende
            køb og alene refundere dig købsprisen for produktet. Du vil ikke
            være berettiget til en refusion for værdien af abonnementet i den
            gratis prøveperiode.
          </TypographyV3>
          <TypographyV3>
            Oura forbeholder sig ret til når som helst at ændre gebyrerne for
            vores betalingstjenester eller eventuelle funktioner eller dele af
            vores betalingstjenester. Du anerkender, at Oura når som helst kan
            ændre gebyrerne for betalingstjenester. I tilfælde af en sådan
            ændring vil Oura give dig besked via den e-mailadresse, der er
            tilknyttet din konto, mindst tredive (30) dage før ændringens
            ikrafttrædelsesdato. Din fortsatte brug af tjenesterne indikerer din
            accept af eventuelle ændringer i gebyrerne. Du er alene ansvarlig
            for alle gældende skatter og vi vil opkræve skatterne hos dig, når
            det kræves ved lov.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Data og kommunikation
          </TypographyV3>
          <TypographyV3>
            Oura kan indsamle og behandle oplysninger om din brug af
            tjenesterne. Du giver dit samtykke til Ouras indsamling og brug af
            sådanne oplysninger samt deling af sådanne oplysninger med
            tredjepartstjenesteudbydere med henblik på at levere, markedsføre og
            forbedre tjenesterne og enhver anden grund beskrevet i
            privatlivspolitikken. Alle personoplysninger, der indsamles af Oura,
            behandles i overensstemmelse med privatlivspolitikken.
          </TypographyV3>
          <TypographyV3>
            <b>
              Ved at acceptere vilkårene og betingelserne i denne aftale og give
              dine kontaktoplysninger til Oura giver du dit udtrykkelige
              samtykke til, at Oura, dets tilknyttede selskaber og agenter fra
              tid til anden må kontakte dig på enhver postadresse, ethvert
              telefonnummer og enhver e-mailadresse, du giver til Oura.
            </b>{' '}
            Dit samtykke betyder, at du accepterer at blive kontaktet af Oura og
            dets serviceudbydere via telefon, e-mail, tekstbesked eller andre
            midler til ethvert formål, herunder, men ikke begrænset til
            meddelelser relateret til tjenesterne og din konto, abonnementer,
            køb, tilgængelige opgraderinger, fakturerings- og
            betalingsbehandlingsproblemer og telemarketingkommunikationer.
            Sådanne autoriserede kommunikationer kan omfatte brug af automatiske
            opkaldsteknologier eller brug af forudindspillede beskeder. Du er
            ansvarlig for eventuelle gebyrer, dine serviceudbydere kan opkræve
            fra dig, når vi kontakter dig. Du anerkender yderligere, at dit
            samtykke til det ovenstående ikke er en betingelse for at bruge
            Oura-tjenesterne, og hvis du ikke ønsker at give samtykke, kan du
            kontakte os og anmode om at blive placeret på en liste over
            personer, som ikke må kontaktes, eller du kan til enhver tid
            fravælge ved at bruge afmeldingsmekanismen, der er angivet i de
            pågældende kommunikationer.
          </TypographyV3>
          <TypographyV3>
            Oura fraskriver sig alt ansvar i henhold til denne aftale for
            eventuelle oplysninger, du giver til Oura, der kan udgøre
            elektroniske patientjournaler eller lignende oplysninger leveret af
            dig eller en slutbruger, uanset indhold, der udtrykker det modsatte
            i denne aftale, eller som ellers krævet i henhold til gældende
            føderale, statslige eller internationale love, regler eller
            bestemmelser.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Intellektuelle ejendomsrettigheder
          </TypographyV3>
          <TypographyV3>
            ŌURA, Ō og OURA er varemærker tilhørende Ōura Health Oy.
            Oura-indhold, Oura-produkter, Oura-funktioner og -tjenester samt
            vores underliggende teknologi er beskyttet af love om ophavsret,
            varemærker, patenter, immaterielle rettigheder og andre love i USA
            og andre lande. Alle rettigheder forbeholdes. Der overdrages ingen
            licens eller ret til at bruge nogen mærker, der vises på eller
            bruges i forbindelse med tjenesterne (i det følgende benævnt
            "varemærker"), hverken underforstået eller på anden måde.
            Tjenesterne kan også indeholde eller henvise til tredjeparts
            varemærker, firmanavne, produktnavne og logoer, som kan være
            registrerede varemærker tilhørende deres respektive ejere. Under
            ingen omstændigheder må du bruge eller kopiere nogen af
            varemærkerne. Intet heri skal fortolkes som en overdragelse af nogen
            licens eller ret til at bruge nogen varemærker, der vises i
            forbindelse med tjenesterne, uden Ouras udtrykkelige skriftlige
            tilladelse.
          </TypographyV3>
          <TypographyV3>
            Alt indhold, der leveres i forbindelse med tjenesterne og denne
            aftale, herunder, men ikke begrænset til webstedet, produktet,
            mobilappen, al tekst og grafik, brugergrænseflader, visuelle
            grænseflader, fotografier, billeder/videoer, elektronisk kunst, lyd,
            data, kommunikationsprogrammer, eksekverbar kode, computerkode og
            data (i det følgende samlet benævnt "indhold"), som er formateret,
            organiseret og samlet i forskellige former, herunder design,
            struktur, udvælgelse, koordinering, udtryk, "udseende og
            fremtræden", arrangement, layout, sider, skærmbilleder og databaser
            af/med sådant indhold, som er indeholdt i indholdet, tjenesterne og
            den underliggende teknologi, og alle andre ophavsretligt beskyttede
            værker, der er forbundet med tjenesterne (i det følgende benævnt
            "ophavsretligt beskyttede værker"), ejes, kontrolleres eller
            licenseres eksklusivt af eller til Oura og er beskyttet af
            amerikanske og internationale ophavsretlige love. Du accepterer, at
            du ikke direkte eller indirekte vil kopiere, reproducere,
            modificere, skabe afledte værker af, distribuere eller offentligt
            vise de ophavsretligt beskyttede værker uden forudgående udtrykkelig
            skriftlig tilladelse fra Oura.
          </TypographyV3>
          <TypographyV3>
            Hvis du sender eller overdrager nogen kommunikationer eller
            materialer til Oura via post, e-mail, telefon eller på anden måde,
            der foreslår eller anbefaler ændringer til tjenesterne, herunder,
            men ikke begrænset til nye funktioner eller funktionaliteter
            relateret dertil eller eventuelle kommentarer, spørgsmål, forslag
            eller lignende (i det følgende kaldet "feedback"), kan Oura frit
            bruge denne feedback uanset andre forpligtelser eller begrænsninger
            mellem parterne vedrørende denne feedback. Oura kan frit bruge, uden
            nogen tilskrivelse eller kompensation til nogen part, alle ideer, al
            knowhow, alle koncepter, teknikker og andre immaterielle rettigheder
            indeholdt i denne feedback til ethvert formål, selvom Oura ikke er
            forpligtet til at bruge denne feedback.
          </TypographyV3>
          <TypographyV3>
            Oura respekterer andres immaterielle rettigheder, og det er vores
            politik at behandle og gennemgå meddelelser om påståede krænkelser
            af ophavsret eller andre gældende love om immateriel ejendom hurtigt
            og effektivt. Eventuelle meddelelser om påståede krænkelser skal
            sendes til Ouras udpegede agent på ip@ouraring.com og skal indeholde
            følgende: (i) en signatur (fysisk eller elektronisk) fra
            ophavsretsejeren eller en person bemyndiget til at handle på vegne
            af ophavsretsejeren, (ii) en beskrivelse af det ophavsretligt
            beskyttede værk, som du hævder, er krænket, (iii) en beskrivelse af
            materialet, som du hævder, er krænkende, og som skal fjernes, eller
            hvortil adgangen skal deaktiveres, samt oplysninger, der er
            tilstrækkelige til at tillade Ouras administratorer at finde
            materialet, (iv) oplysninger, der er tilstrækkelige til, at vi kan
            kontakte dig, såsom adresse, telefonnummer og e-mailadresse, (v) en
            erklæring om, at du i god tro mener, at brugen af materialet på den
            måde, der klages over, ikke er godkendt af ophavsretsejeren, dennes
            agent eller loven, og (vi) en erklæring om, at oplysningerne i
            meddelelsen er nøjagtige, og at du under strafansvar for mened er
            ophavsretsejeren eller er bemyndiget til at handle på vegne af
            ejeren af en ophavsret, der angiveligt krænkes.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Ansvarsfraskrivelse for garanti
          </TypographyV3>
          <TypographyV3>
            TJENESTERNE LEVERES TIL DIG "SOM DE ER OG FOREKOMMER MED EVENTUELLE
            DEFEKTER" OG "I DEN FORM, DE STILLES TIL RÅDIGHED" UDEN NOGEN FORM
            FOR GARANTI, OG OURA OG DETTES AFFILIEREDE SELSKABER,
            DATTERSELSKABER, DIREKTIONSMEDLEMMER, BESTYRELSESMEDLEMMER,
            MEDARBEJDERE, REPRÆSENTANTER, AGENTER, PARTNERE OG LICENS-UDSTEDERE
            FRASKRIVER HERVED ALLE GARANTIER OG BETINGELSER VEDRØRENDE
            TJENESTERNE, UANSET OM DE ER UDTRYKTE ELLER UNDERFORSTÅEDE, OG
            FRASKRIVER SPECIFIKT ALLE UNDERFORSTÅEDE GARANTIER FOR EJERSKAB,
            SALGBARHED, EGNETHED TIL ET BESTEMT FORMÅL, TILFREDSSTILLENDE
            KVALITET OG IKKE-KRÆNKELSE. OURA GARANTERER IKKE IMOD FORSTYRRELSE
            AF DIN NYDELSE AF TJENESTERNE, TILGÆNGELIGHEDEN AF INDHOLD, AT
            FUNKTIONERNE I TJENESTERNE VIL OPFYLDE DINE KRAV, AT TJENESTERNE VIL
            VÆRE FRI FOR VIRUSER ELLER ANDRE SKADELIGE KOMPONENTER, AT DRIFTEN
            AF TJENESTERNE VIL VÆRE FRI FOR AFBRYDELSER ELLER VIL VÆRE FEJLFRI,
            AT FEJL I TJENESTERNE VIL BLIVE RETTET, ELLER AT FUNKTIONERNE I
            TJENESTERNE VIL FUNGERE MED ANDRE MOBILAPPS ELLER ANDEN HARDWARE
            ELLER INDEN FOR ET SYSTEM. INGEN MUNDELIG ELLER SKRIFTLIG
            INFORMATION ELLER RÅDGIVNING GIVET AF OURA ELLER EN OURA-AUTORISERET
            REPRÆSENTANT VIL SKABE EN GARANTI. VISSE JURISDIKTIONER TILLADER
            IKKE FRASKRIVELSE AF UNDERFORSTÅEDE GARANTIER ELLER BEGRÆNSNINGER AF
            GÆLDENDE LOVBESTEMTE FORBRUGERRETTIGHEDER, SÅ DEN OVENSTÅENDE
            FRASKRIVELSE GÆLDER MÅSKE IKKE.
          </TypographyV3>
          <TypographyV3>
            UANSET DET FOREGÅENDE GARANTERER OURA TIL DEN OPRINDELIGE
            SLUTBRUGERKØBER, AT PRODUKTET ER FRI FOR MATERIALE- OG
            PRODUKTIONSFEJL I ÉT (1) ÅR FRA KØBSDATOEN. Hvis lokale lovgivning,
            der er gældende for dig på købstidspunktet, kræver en garantiperiode
            længere end ét (1) år, skal denne garanti forlænges i det omfang,
            det kræves af sådan lovgivning. Inden for garantiperioden skal Oura
            reparere eller erstatte uden omkostninger for dig eventuelle
            komponenter af produktet, der ikke opfylder den begrænsede garanti.
            Du er ansvarlig for eventuelle tilknyttede transportomkostninger.
            Erstatningsprodukter kan være nye eller renoverede efter vores skøn.
            Denne begrænsede garanti gælder ikke for (i) normal slid og ælde,
            herunder ridser og skrammer, (ii) forbrugsdele inkluderet i
            produktet, såsom batterier, medmindre produktet er beskadiget på
            grund af en defekt i materialer eller håndværk, (iii) skade som
            følge af din manglende overholdelse af instruktionerne til
            Ōura-produktet eller de instruktioner, der er tilgængelige på
            hjemmesiden, (iv) skade som følge af en ulykke, oversvømmelse,
            brand, misbrug eller overlast, (v) skade som følge af service udført
            eller skade som følge af manipulation eller ændringer af produktet
            foretaget af en person, der ikke er autoriseret af Ōura, eller (vi)
            brug af produktet med enhver applikation eller software, der ikke er
            mobilappen.
          </TypographyV3>
          <TypographyV3>
            Oura forbeholder sig den eksklusive ret til at reparere eller
            erstatte produktet eller tilbyde en fuld refusion efter eget skøn.
            En sådan løsning skal være dit eneste og eksklusive retsmiddel for
            enhver overtrædelse af denne begrænsede garanti. Garantireparationer
            og -udskiftninger er underlagt en ny garanti, som gælder i resten af
            den oprindelige garantiperiode på et (1) år, dog mindst 90 dage.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Ansvarsbegrænsning
          </TypographyV3>
          <TypographyV3>
            UNDER INGEN OMSTÆNDIGHEDER VIL OURA, DETTES AFFILIEREDE SELSKABER,
            DATTERSELSKABER, DIREKTIONSMEDLEMMER, BESTYRELSESMEDLEMMER,
            MEDARBEJDERE, REPRÆSENTANTER, AGENTER, PARTNERE ELLER LICENSGIVERE
            VÆRE ANSVARLIG FOR SKADER AF NOGEN ART, UNDER NOGEN JURIDISK TEORI,
            SOM OPSTÅR I FORBINDELSE MED DIN BRUG ELLER MANGLENDE EVNE TIL AT
            BRUGE TJENESTERNE ELLER NOGET INDHOLD, DER ER ASSOCIERET MED
            TJENESTERNE, ELLER SÅDANNE ANDRE SIDER ELLER NOGEN TJENESTER ELLER
            VARER, DER ER INDHENTET VIA TJENESTERNE, HERUNDER EVENTUELLE
            DIREKTE, INDIREKTE ELLER HÆNDELIGE SKADER, SKADER FOR KONKRET
            DOKUMENTEREDE TAB, FØLGESKADER ELLER PUNITIVE SKADER, HERUNDER, MEN
            IKKE BEGRÆNSET TIL PERSONSKADE, SVIE OG SMERTE, FØLELSESMESSIG
            BELASTNING, TAB AF INDTÆGTER, TAB AF FORTJENESTE, TAB AF OMSÆTNING
            ELLER FORVENTET INDTJENING, MISTET FORRETNINGSMULIGHED,
            FORRETNINGSFORSTYRRELSE, MANGLENDE BRUG, TAB AF GODT OMDØMME, TAB AF
            DATA, OG UANSET OM DET ER FORÅRSAGET VED TORT (HERUNDER UAGTSOMHED),
            KONTRAKTMISLIGHOLDELSE ELLER PÅ ANDEN VIS, OG SELVOM DET KUNNE
            FORESES. DISSE UNDTAGELSER ELLER BEGRÆNSNINGER VIL GÆLDE, UANSET OM
            OURA ER ADVARET OM MULIGHEDEN FOR SÅDANNE SKADER ELLER IKKE.
          </TypographyV3>
          <TypographyV3>
            DET FOREGÅENDE PÅVIRKER IKKE NOGET ANSVAR, SOM IKKE KAN UDELUKKES
            ELLER BEGRÆNSES I HENHOLD TIL GÆLDENDE LOV. I DET OMFANG ANSVAR IKKE
            KAN UDELUKKES ELLER BEGRÆNSES SOM ANFØRT OVENFOR, SKAL OURA UNDER
            INGEN OMSTÆNDIGHEDER VÆRE ANSVARLIG FOR NOGET KRAV, UANSET OM DET ER
            BASERET PÅ KONTRAKT, ERSTATNINGSANSVAR ELLER UNDER NOGEN ANDEN
            ANSVARSTEORI, DER OVERSTIGER $100.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Forholdsregler
          </TypographyV3>
          <TypographyV3>
            TJENESTERNE ER IKKE ET MEDICINSK UDSTYR, OG DU ACCEPTERER
            UDTRYKKELIGT, AT TJENESTERNE IKKE INVOLVERER LEVERING AF MEDICINSK
            RÅDGIVNING FRA OURA. TJENESTERNE ER IKKE BEREGNET TIL AT
            DIAGNOSTISERE, BEHANDLE, HELBREDE ELLER FOREBYGGE NOGEN SYGDOM ELLER
            MEDICINSK TILSTAND. TJENESTERNE ER KUN TIL INFORMATION OG KAN IKKE
            ERSTATTE LÆGERS ELLER MEDICINSKE FAGFOLKS TJENESTER.
          </TypographyV3>
          <TypographyV3>
            TJENESTERNE, HERUNDER ALLE OPLYSNINGER, TEKST, FOTOGRAFIER,
            BILLEDER, ILLUSTRATIONER, GRAFIK, LYD, VIDEO OG LYDVIDEOKLIP SAMT
            ANDRE MATERIALER, UANSET OM DE LEVERES AF OS ELLER TREDJEPARTER, ER
            IKKE BEREGNET TIL OG BØR IKKE BRUGES I STEDET FOR (a) RÅD FRA DIN
            LÆGE ELLER ANDRE MEDICINSKE FAGFOLK, (b) ET BESØG, EN
            TELEFONOPRINGNING ELLER EN KONSULTATION MED DIN LÆGE ELLER ANDRE
            MEDICINSKE FAGFOLK ELLER (c) OPLYSNINGER, DER ER ANFØRT PÅ ELLER I
            NOGET PRODUKT ELLER NOGEN EMBALLAGE.
          </TypographyV3>
          <TypographyV3>
            SKULLE DU HAVE NOGEN SUNDHEDSRELATEREDE SPØRGSMÅL, SKAL DU OMGÅENDE
            RINGE TIL ELLER BESØGE DIN LÆGE ELLER EN ANDEN MEDICINSK FAGPERSON.
            SKULLE DU HAVE BRUG FOR AKUT HJÆLP, SKAL DU RINGE TIL DIN LÆGE ELLER
            PÅ TELEFON 112 MED DET SAMME. DU MÅ ALDRIG IGNORERE MEDICINSK
            RÅDGIVNING ELLER UDSÆTTE AT SØGE MEDICINSK RÅDGIVNING PÅ GRUND AF
            NOGEN OPLYSNINGER, DER FREMLÆGGES VIA TJENESTERNE, OG DU MÅ IKKE
            BRUGE TJENESTERNE ELLER NOGEN OPLYSNINGER, DER FREMLÆGGES VIA
            TJENESTERNE, TIL DIAGNOSTICERING ELLER BEHANDLING AF ET
            SUNDHEDSPROBLEM. OVERFØRSEL OG MODTAGELSE AF TJENESTERNE HELT ELLER
            DELVIST, ELLER KOMMUNIKATION VIA INTERNETTET, E-MAIL ELLER ANDRE
            MIDLER UDGØR ELLER SKABER IKKE ET LÆGE-PATIENT- ELLER ET
            TERAPIST-PATIENT-FORHOLD ELLER ET ANDET FORHOLD SVARENDE TIL ET
            FORHOLD TIL EN SUNDHEDSFAGPERSON MELLEM DIG OG OURA.
          </TypographyV3>
          <TypographyV3>
            Du bør altid konsultere en læge, før du foretager ændringer i din
            søvn eller aktivitet baseret på oplysninger fra tjenesterne, eller
            hvis du har spørgsmål vedrørende en medicinsk tilstand. Oura er ikke
            ansvarlig for eventuelle sundhedsproblemer, der kan opstå som følge
            af oplysninger, du bliver bekendt med via tjenesterne. Hvis du
            foretager ændringer i din søvn eller aktivitet baseret på
            tjenesterne, accepterer du, at du gør det fuldt ud på eget ansvar.
            Det er vigtigt at være opmærksom på din krops reaktioner. For
            eksempel, hvis du oplever uventet, gentaget eller langvarig smerte,
            træthed eller ubehag på grund af ændringer i din søvn eller
            aktivitet, anbefales det, at du konsulterer en læge, inden du
            fortsætter med sådanne ændringer. Oplysningerne i tjenesterne kan
            være vildledende, hvis dine fysiologiske funktioner og reaktioner
            afviger væsentligt fra populationsgennemsnittet på grund af
            medicinske tilstande eller sjældne naturligt forekommende forskelle.
          </TypographyV3>
          <TypographyV3>
            Pas på, at produktet, du har på, ikke sidder fast i faste strukturer
            eller tunge genstande. Hvis du oplever rødmen eller irritation på
            huden på din finger, mens du har produktet på, skal du fjerne det
            øjeblikkeligt. Hvis symptomerne fortsætter i mere end 2-3 dage uden
            brug af produktet, bør du kontakte en læge.
          </TypographyV3>
          <TypographyV3>
            Vores produkt må under ingen omstændigheder placeres i munden. Ouras
            produkt er ikke et legetøj og er heller ikke beregnet til brug af
            børn. Børn bør ikke efterlades uden opsyn med dette produkt, da det
            kan udgøre en kvælningsfare.
          </TypographyV3>
          <TypographyV3>
            Tjenesterne kan indeholde links til andre websteder vedligeholdt af
            tredjeparter. Du erkender og accepterer, at sådanne links kun
            leveres for din bekvemmelighed og ikke afspejler nogen godkendelse,
            tilknytning, relation eller sponsorering fra Oura med hensyn til
            udbyderen af sådanne linkede websteder eller kvaliteten,
            pålideligheden eller nogen anden karakteristika eller funktion af
            sådanne linkede websteder. Du erkender yderligere og accepterer, at
            Oura på ingen måde er ansvarlig (herunder, men ikke begrænset til
            med hensyn til eventuelle tab eller skader, du måtte lide) for noget
            forhold vedrørende med det linkede websted, herunder, men ikke
            begrænset til indholdet på eller gennem et sådant linket websted
            eller din afhængighed heraf. Derudover bør du være opmærksom på, at
            din brug af ethvert tredjepartswebsted er underlagt de vilkår og
            betingelser, der gælder for det pågældende websted, herunder de
            privatlivspolitikker (eller manglen på sådanne) for sådanne
            websteder. Hvis en tredjepart linker til tjenesterne, er det ikke
            nødvendigvis en indikation på godkendelse, tilknytning, relation
            eller sponsorering af eller med Oura. Oura er måske ikke engang klar
            over, at en tredjepart har linket til tjenesterne.
          </TypographyV3>
          <TypographyV3>
            Alt andet indhold, der ikke ejes af Oura, tilhører dets respektive
            ejer. Du erkender og accepterer, at sådant indhold leveres af dets
            ejer og ikke afspejler nogen godkendelse, tilknytning, relation
            eller sponsorering fra Oura med hensyn til udbyderen af sådant
            indhold. Du erkender yderligere og accepterer, at Oura ikke er
            ansvarlig eller erstatningspligtig på nogen måde (herunder, men ikke
            begrænset til med hensyn til eventuelle tab eller skader, du måtte
            lide) for noget indhold leveret af tredjeparter, herunder, men ikke
            begrænset til din afhængighed deraf. OURA FREMSÆTTER INGEN PÅSTANDE
            ELLER GARANTIER MED HENSYN TIL NOGET TREDJEPARTSINDHOLD..
          </TypographyV3>
          <TypographyV3>
            Du accepterer at friholde, skadesløsholde og forsvare Oura, dets
            datterselskaber, associerede selskaber, direktionsmedlemmer,
            bestyrelsesmedlemmer, medarbejdere, repræsentanter, agenter,
            partnere, licensgivere, efterfølgere og rettighedshavere mod ethvert
            søgsmål, krav og ansvar og enhver skadeserstatning, gæld og påstand,
            herunder rimelige omkostninger og advokatsalærer, fremsat af enhver
            person, der opstår som følge af eller i forbindelse med (i) din brug
            af tjenesterne, herunder, men ikke begrænset til enhver, der bruger
            din konto eller dine legitimationsoplysninger, (ii) overtrædelse af
            denne aftale af dig eller enhver, der bruger din konto eller dine
            legitimationsoplysninger, (iii) enhver information, der bruges,
            opbevares eller transmitteres i forbindelse med din konto eller dine
            legitimationsoplysninger, (iv) overtrædelse af
            tredjepartsrettigheder, herunder, men ikke begrænset til
            privatlivets fred, offentlighed, intellektuel ejendom eller andre
            ejendomsrettigheder af dig eller enhver, der bruger din konto eller
            dine legitimationsoplysninger, eller (v) overtrædelse af enhver lov,
            regulering eller andet juridisk krav.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Meddelelse til brugere i Californien
          </TypographyV3>
          <TypographyV3>
            I henhold til California Civil Code Section 1789.3 er californiske
            brugere af tjenesterne berettiget til følgende specifikke meddelelse
            om forbrugerrettigheder:
          </TypographyV3>
          <TypographyV3>
            Complaint Assistance Unit under Division of Consumer Services under
            California Department of Consumer Affairs kan kontaktes skriftligt
            på adressen 1625 N. Market Blvd, Suite N 112, Sacramento, California
            95834 eller telefonisk på +1 (800) 952-5210.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Opsigelse, annullering
          </TypographyV3>
          <TypographyV3>
            Denne aftale fortsætter i fuld kraft, indtil den opsiges eller
            annulleres i henhold til denne aftale.
          </TypographyV3>
          <TypographyV3>
            Oura har ret til at opsige denne aftale (i) af enhver årsag efter at
            have givet dig tredive (30) dages varsel, (ii) øjeblikkeligt i
            tilfælde af din væsentlige misligholdelse af denne aftale, undtagen
            manglende betaling af gebyrer, eller (iii) ved manglende betaling af
            gebyrer. Uanset det foregående forbeholder Oura sig retten til efter
            eget skøn og uden varsel til enhver tid og af enhver årsag at
            fjerne, ændre, suspendere eller deaktivere adgangen til hele eller
            dele af tjenesterne.
          </TypographyV3>
          <TypographyV3>
            Du kan opsige aftalen af en hvilken som helst grund ved at give
            tredive (30) dages varsel til Oura ved at besøge
            support.ouraring.com og oprette en sag. Du er ansvarlig for alle
            gebyrer, der påløber før og i opsigelsesperioden.
          </TypographyV3>
          <TypographyV3>
            Afsnittene med titlerne Forholdsregler, Intellektuelle
            ejendomsrettigheder, Data og kommunikation, Skadesløsholdelse,
            Ansvarsfraskrivelse for garanti, Ansvarsbegrænsning, Lovvalg,
            Jurisdiktion, Obligatorisk bindende voldgift, Afkald på
            gruppesøgsmål og betalingsforpligtelser for gebyrer, der er påløbet
            før og under enhver opsigelsesperiode, skal overleve opsigelse af
            denne aftale uanset årsag.
          </TypographyV3>
          <TypographyV3>
            Restriktioner for slutbrug i den føderale regering
          </TypographyV3>
          <TypographyV3>
            Hvis du er et amerikansk føderalt regeringsorgan eller -agentur
            eller handler på vegne af et sådant organ eller agentur, er
            tjenesterne "Kommercielle emner" som defineret i 48 C.F.R. §2.101
            bestående af "Kommerciel computersoftware" og "Kommerciel
            computersoftwaredokumentation", som disse termer anvendes i 48
            C.F.R. §12.212 eller 48 C.F.R. §227.7202. I overensstemmelse med 48
            C.F.R. §12.212 eller 48 C.F.R. §227.7202-1 gennem 227.7202-4, i den
            udstrækning det er relevant, er tjenesten licenseret til dig med kun
            de rettigheder, som er angivet i vilkårene og betingelserne i denne
            aftale. Hvis du er en amerikansk føderal
            regeringsbestillingsaktivitet eller ansat i en sådan
            bestillingsaktivitet, der foretager indkøb gennem en
            GSA-plankontrakt i din egenskab af agent for en sådan
            bestillingsaktivitet, kan vilkårene i denne offentliggjorte aftale
            og privatlivspolitikken være anderledes.
          </TypographyV3>
          <TypographyV3>
            Eksportoverensstemmelse og anvendelsesbegrænsninger
          </TypographyV3>
          <TypographyV3>
            Du må ikke direkte eller indirekte eksportere eller geneksportere
            tjenesterne eller nogen teknisk information relateret hertil til
            nogen destination eller person, hvis dette er forbudt eller
            indskrænket af gældende lov, herunder, men ikke begrænset til alle
            gældende amerikanske eksportkontrollove og -regler.
          </TypographyV3>
          <TypographyV3>
            Lovvalg, jurisdiktion, obligatorisk bindende voldgift, afkald på
            gruppesøgsmål
          </TypographyV3>
          <TypographyV3>
            Ethvert søgsmål vedrørende denne aftale, tjenesterne og dit forhold
            til Oura er underlagt og skal forstås og fortolkes i
            overensstemmelse med delstatens Californiens love uden hensyntagen
            til dens regler om lovkonflikt OG VIL SPECIFIKT IKKE VÆRE UNDERLAGT
            AF DE FORENEDE NATIONERS KONVENTIONER OM KONTRAKTER FOR
            INTERNATIONALT SALG AF VARER, HVIS DE I ØVRIGT FINDER ANVENDELSE. Du
            accepterer at løse enhver tvist og ethvert krav, der opstår i
            forbindelse med denne aftale eller tjenesterne, gennem endelig og
            bindende voldgift ved en enkelt voldgiftsmand. Dette inkluderer
            tvister vedrørende fortolkning eller anvendelse af denne
            "bestemmelse om obligatorisk voldgift", herunder dens eksigibilitet,
            gyldighed og mulighed for tilbagekaldelse heraf. Uanset det
            foregående kan begge parter anlægge et søgsmål udelukkende med
            henblik på udstedelse af et fogedforbud mod uautoriseret brug eller
            misbrug af tjenesterne eller overtrædelse af enhver intellektuel
            ejendomsret. Under forbehold af den obligatoriske
            voldgiftsbestemmelse samtykker parterne uigenkaldeligt i at anlægge
            en eventuel sag om at løse eller håndhæve krav, der opstår under
            eller i forbindelse med denne aftale, ved de føderale eller
            statslige domstole i San Francisco, Californien, og hver part
            underlægger sig uigenkaldeligt sådanne domstoles eksklusive
            jurisdiktion vedrørende alle sådanne retssager, sagsanlæg og
            forhold. Bortset fra i det omfang, det er forbudt ved gældende lov,
            erklærer parterne, at ethvert krav eller enhver årsag til sagsanlæg,
            der opstår ud af eller er relateret til brugen af tjenesterne eller
            denne aftale, skal være indgivet inden for et (1) år efter, at
            sådant krav eller sådan årsag til sagsanlæg er opstået, og at
            muligheden herfor ellers vil være gået tabt for evigt. Dette afsnit
            gælder ikke for brugere, der bor i Den Europæiske Union. Hvis du er
            en bruger, som bor i Den Europæiske Union, skal er denne aftale
            underlagt finsk lovgivning, og de finske domstole skal have
            eksklusiv jurisdiktion til at høre tvister i relation til denne
            aftale. Denne bestemmelse finder ikke anvendelse for forbrugere i
            lande, der kræver, at aftaler skal reguleres af den lokale
            lovgivning i forbrugerens land. Det engelske sprog skal anvendes i
            alle dokumenter, meddelelser og fortolkninger af denne aftale. Du
            accepterer også at give afkald på enhver ret til at gøre krav
            gældende over for Oura som repræsentant for eller medlem af ethvert
            gruppesøgsmål eller kollektivt søgsmål, bortset fra hvor et sådant
            afkald er forbudt ved lov eller anses af en domstol for at være i
            strid med offentlig politik.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Diverse
          </TypographyV3>
          <TypographyV3>
            Du anerkender, at Oura har ret til at overvåge brugen af tjenesterne
            for at sikre overholdelse af aftalen.
          </TypographyV3>
          <TypographyV3>
            Intet afkald på nogen betingelse eller bestemmelse i denne aftale,
            uanset om det sker som følge af adfærd eller på anden måde, i et
            eller flere tilfælde, skal anses for at være eller udgøre et afkald
            på nogen anden betingelse eller bestemmelse heri, uanset om de er
            ensartede eller ej, og et sådant afkald skal ikke udgøre et fortsat
            afkald på nogen sådan betingelse eller bestemmelse heri. Intet
            afkald skal være bindende, medmindre det er udfærdiget skriftligt af
            den part, der foretager afkaldet.
          </TypographyV3>
          <TypographyV3>
            Du kan ikke overdrage denne aftale til nogen anden part, og ethvert
            forsøg på at gøre det er ugyldigt.
          </TypographyV3>
          <TypographyV3>
            Hvis en bestemmelse i denne aftale vurderes at være ulovlig eller
            uden retskraft, skal den pågældende bestemmelse håndhæves i størst
            muligt omfang, og de øvrige bestemmelser forbliver fuldt ud i kraft
            og med fuld retskraft.
          </TypographyV3>
          <TypographyV3>
            Denne aftale og privatlivspolitikken udgør den fuldstændige og
            eksklusive erklæring om aftalen mellem dig og Oura vedrørende
            tjenesterne og tilsidesætter alle tidligere eller samtidige
            meddelelser, anbringender, erklæringer og forståelser, hvad enten de
            er mundtlige eller skriftlige, mellem parterne.
          </TypographyV3>
          <TypographyV3>
            I tilfælde af uoverensstemmelse mellem vilkårene i denne aftale og
            vilkårene i privatlivspolitikken, har vilkårene i denne aftale
            forrang.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Ændring af vilkår og tjenester
          </TypographyV3>
          <TypographyV3>
            Oura forbeholder sig retten til når som helst, af en hvilken som
            helst grund og efter eget skøn at opdatere denne aftale og/eller
            privatlivspolitikken ved at offentliggøre opdaterede vilkår.
            Medmindre andet angives af Oura, vil eventuelle ændringer træde i
            kraft på et fremadrettet grundlag fra datoen for offentliggørelsen.
            Oura vil underrette dig om eventuelle væsentlige ændringer i aftalen
            eller tjenesterne. Ved fortsat at skaffe dig adgang til eller bruge
            tjenesterne, efter at vi har givet dig besked om en ændring,
            accepterer du at være bundet af den ændrede aftale. Hvis den ændrede
            aftale ikke er acceptabel for dig, er din eneste mulighed at ophøre
            med at bruge tjenesterne. Oura og dennes tredjepartsserviceudbydere
            kan når som helst, af enhver grund og efter eget skøn foretage
            forbedringer og/eller ændringer i de beskrevne tjenester, funktioner
            og priser. Mobilappen kan downloade og installere opgraderinger,
            opdateringer og yderligere funktioner med henblik på at forbedre,
            forstærke og videreudvikle tjenesterne. Oura forbeholder sig ret til
            når som helst at ændre eller afbryde tjenesterne eller dele deraf
            midlertidigt eller permanent med eller uden varsel. Du accepterer,
            at Oura ikke er ansvarlig over for dig eller nogen tredjepart for
            nogen ændring, suspension eller afbrydelse af tjenesterne.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            ŌURAS LEVERINGSBETINGELSER
          </TypographyV3>
          <TypographyV3>
            <em>Sidst opdateret: 4. marts 2024</em>
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Canada og Storbritannien
          </TypographyV3>
          <TypographyV3>
            Oura vil levere produkterne iht. DDP-Incoterm (Delivered Duty Paid).
            Oura er ansvarlig for at importere og levere produkterne til det
            navngivne sted i køberens land. Oura er ansvarlig for at betale alle
            omkostninger i forbindelse med import af produkterne til køberens
            land og vil opkræve skatter og afgifter med de gældende satser
            baseret på leveringsadressen for produkterne. Oura vil udstede en
            overensstemmende skattefaktura for eventuelle lokale indirekte
            skatter og afgifter, der ifaldes ved salget, som krævet i henhold
            til lokal lovgivning.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Den Europæiske Union og USA
          </TypographyV3>
          <TypographyV3>
            Oura vil levere produkterne fra lokale distributionscentre til det
            navngivne sted i køberens pågældende jurisdiktion. Oura vil opkræve
            skatter og afgifter med de gældende satser baseret på
            leveringsadressen for produkterne i overensstemmelse med lokale
            regler.
          </TypographyV3>
          <TypographyV3 Element="h2" variant="h3">
            Uden for de ovennævnte lande
          </TypographyV3>
          <TypographyV3>
            Oura vil levere produkterne iht. DAP-Incoterm, hvor ejerskabet
            overføres til køberen umiddelbart før import. Oura betaler for
            fragten til det navngivne sted uden for køberens land, men er ikke
            ansvarlig for at importere produkterne til købers land eller for
            levering af produkterne til det navngivne sted i købers land. Køber
            er ansvarlig for alle omkostninger i forbindelse med import af
            produkterne. Oura vil ikke bidrage til opkrævning af nogen skatter
            eller afgifter på købers vegne.
          </TypographyV3>
          <TypographyV3>
            I tilfælde af konflikt mellem den engelske version af denne aftale
            og oversættelser heraf til andre sprog har den engelske version
            forrang, medmindre og undtagen som påkrævet i henhold til gældende
            lokal lovgivning.
          </TypographyV3>
        </TypographyRhythm>
      </LayoutGrid>
    </PageLayoutV3>
  );
};

export default Page;
